// Action Types
export const FETCH_COMP_BU_FIN_REQUEST =
  "FETCH_COMP_BU_FIN_REQUEST";
export const FETCH_COMP_BU_FIN_SUCCESS =
  "FETCH_COMP_BU_FIN_SUCCESS";
export const FETCH_COMP_BU_FIN_FAILURE =
  "FETCH_COMP_BU_FIN_FAILURE";

// Action Creators
export const fetchCompBuFinancialRequest = (payload) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_COMP_BU_FIN_REQUEST,
      payload,
    });
  };
};
export const fetchCompBuFinancialSuccess = (data) => ({
  type: FETCH_COMP_BU_FIN_SUCCESS,
  payload: data,
});
export const fetchCompBuFinancialFailure = (error) => ({
  type: FETCH_COMP_BU_FIN_FAILURE,
  payload: error,
});


